import { useEffect } from 'react';

const SimpleConfirmation = ({ show, blockStatus, onConfirm, onUnblock, onClose }) => {
  useEffect(() => {
    // Future cleanup logic if needed
  }, [show]);

  if (!show) return null;

  return (
    <div id="customConfirmDialog">
      <div className="confirm-dialog-content">
        {blockStatus === "blocked_by_me" ? (
          <>
            <p>You have blocked messeges between you and this user.</p>
            <div className="dialog-buttons">
              <button className="confirmBtn" onClick={onUnblock}>Unblock</button>
              <button className="cancelBtn" onClick={onClose}>Close</button>
            </div>
          </>
        ) : blockStatus === "user_blocked" ? (
          <>
            <p>You have been blocked by this user from messaging them.</p>
            <div className="dialog-buttons">
              <button className="cancelBtn" onClick={onClose}>Close</button>
            </div>
          </>
        ) : (
          <>
            <p>Only English characters are allowed. Please remove any non-English characters.</p>
            <div className="dialog-buttons">
              <button className="confirmBtn" onClick={onConfirm}>Okay</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SimpleConfirmation;
